module.exports = __webpack_public_path__ + "static/media/bg.ed5024b7.png";